import './header.less';
import './header';
import Navigation from './nav/index';
import QuickContacts from './quick-contacts/index';

// trim-below
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import block from 'bem-cn-lite';

import menu from './menu';

const b = block('header');

class Header extends Component {
	render() {
		const pathname = this.context.router.route.location.pathname.replace('/', '');

		return (
			<header className={b()} itemScope itemType="http://schema.org/Organization">
				<div className={b('top-line')}>
					<div className={b('container')}>
						<QuickContacts />
					</div>
				</div>
				<div className={b('sticky')}>
					<div className={b('container')}>
						<a href="/" className={b('logo')}><span itemProp="name">SQSkouras</span></a>
						<span className={b('menu-trigger')}>
							<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path fill="#fff" d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/></svg>
						</span>
						<div className={b('overview')} />
						<Navigation items={menu} pathname={pathname} className={b('nav')} />
					</div>
				</div>
			</header>
		);
	}
}

Header.contextTypes = {
	router: PropTypes.object
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/index.jsx